<template>
  <text-field
    :clearable="false"
    :appendIcon="passwordVisible ? 'visibility_off' : 'visibility'"
    :type="passwordVisible ? 'text' : 'password'"
    @click:append="passwordVisible = !passwordVisible"
    :value="value"
    v-bind="$attrs"
    v-on="$listeners"/>
</template>

<script>
export default {
    name: 'PasswordField',
    props: {
        value: String
    },
    data: () => ({
        passwordVisible: false
    })
}
</script>
